const { Model } = require('./core');

class Item extends Model {
  constructor(data = {}) {
    super(data);

    this.requestParams = { from_item: true };
  }
}

module.exports = {
  Item,
};
